import React from 'react';
import { SelectInput, usePermissions, useTranslate } from 'react-admin';
import { useFetchLiquidityPositions } from '~/hooks/bankAccounts';
import { Skeleton } from '@material-ui/lab';
import { FORM_CONTROL_WIDTH } from '~/hooks/useListFilterStyles';

interface BankAccountSelectProps {
  label: string;
  source: string;
  className?: string;
  alwaysOn?: boolean;
  allowEmpty?: boolean;
  emptyText?: string;
}

const BankAccountSelect: React.FC<BankAccountSelectProps> = ({
  label,
  source,
  className,
  alwaysOn,
  allowEmpty,
  emptyText,
  ...rest
}) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  const hasPermissions = permissions?.includes('virtualLiquidityPosition.view');
  const { data, isFetching } = useFetchLiquidityPositions(hasPermissions);
  if (!hasPermissions) return null;
  if (isFetching) {
    return (
      <Skeleton variant='rect' width={FORM_CONTROL_WIDTH} height={45} style={{ borderRadius: 4 }} />
    );
  }

  const options =
    data?.data?.map((item) => ({
      id: item.id,
      name: `${item?.alias} (${item?.currency})`,
    })) ?? [];
  return (
    <SelectInput
      label={label}
      source={source}
      choices={options}
      className={className}
      alwaysOn={alwaysOn}
      allowEmpty={allowEmpty}
      emptyText={emptyText || translate('utils.any')}
      {...rest}
    />
  );
};

export default BankAccountSelect;
